export enum Currency {
  Euro = 'EURO',
}

export type MoneyBag = {
  taxExcluded: number
  taxIncluded: number
  currency: Currency
}

export enum ProductEnum {
  AssistanceDomestique = 'ASSISTANCE_DOMESTIQUE',
  AssistanceDomestiqueProfessionnel = 'ASSISTANCE_DOMESTIQUE_PROFESSIONNEL',
  PublicLiability = 'PUBLIC_LIABILITY',
  PublicLiabilityEcomm = 'PUBLIC_LIABILITY_ECOMM',
  MultiRisk = 'MULTI_RISK',
  Cyber = 'CYBER',
  Auto = 'AUTO',
  Legal = 'LEGAL',
  Decennial = 'DECENNIAL',
  KeyPerson = 'KEY_PERSON',
  DAndO = 'D_AND_O',
  Health = 'HEALTH',
  Life = 'LIFE',
  AutoMission = 'AUTO_MISSION',
  Other = 'OTHER',
  MreAcheel = 'MRE_ACHEEL',
}

export enum UserTypeEnum {
  Particulier = 'PARTICULIER',
  Professionnel = 'PROFESSIONNEL',
  Collectivite = 'COLLECTIVITE',
}

export enum CompanyTypeEnum {
  PilliotAssurances = 'PILLIOT_ASSURANCES',
}

export enum CountryEnum {
  France = 'FRANCE',
}

export enum PaymentFrequency {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Ponctuel = 'PONCTUEL',
  Bimestriel = 'BIMESTRIEL',
  Trimestriel = 'TRIMESTRIEL',
  Semestriel = 'SEMESTRIEL',
}

export enum CompanySizeLabel {
  Tpe = 'TPE',
  Pme = 'PME',
  Se = 'SE',
  Eti = 'ETI',
}

export * as MultiRisk from './multi-risk'
export * as MreAcheel from './mre-acheel'
export * as AssistanceDomestique from './assistance-domestique'
export * as AssistanceDomestiqueProfessionnel from './assistance-domestique-professionnel'
